// extracted by mini-css-extract-plugin
module.exports = {"container":"_2ANjIM88QIcJkGDU0ZwISN","icon":"_3wf0hg8I9uSblSwTZKx6QS"};